import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URI,
  headers: {
    'X-Tenant-Id': process.env.REACT_APP_TENANT_ID,
  },
});

export { API };
